import { useQuery } from '@tanstack/react-query';

import { getOperationsFleet } from '@/api/operations';
import { useAuthStore } from '@/stores/authStore';

/**
 * The organization's device stages for the shell (search and "Needs you").
 *
 * Same query key and request as the Devices page, Overview and the device
 * page, so the shell reads their cache. It sets no refetch interval: it is
 * refreshed when those pages poll or when a change invalidates the fleet.
 */
export function useConsoleFleet(enabled: boolean) {
  const isOwner = useAuthStore((state) => state.isOwner);
  const actingOrgId = useAuthStore((state) => state.actingOrgId);
  const userOrganizationId = useAuthStore((state) => state.user?.organization_id ?? null);
  const scopeOrganizationId = isOwner ? actingOrgId : userOrganizationId;

  return useQuery({
    queryKey: ['operations-fleet', scopeOrganizationId],
    queryFn: () =>
      getOperationsFleet({
        organization_id: isOwner ? (scopeOrganizationId ?? undefined) : undefined,
      }),
    enabled: enabled && scopeOrganizationId != null,
  });
}
